export default __webpack_public_path__ + "static/media/paraAngle.e87d53ab.jpg";